import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown, Users } from 'lucide-react';
import { IMAGES } from '../lib/constants';
interface LandingScreenProps {
  onStart: () => void;
}
export function LandingScreen({
  onStart
}: LandingScreenProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} className="flex flex-col items-center text-center px-4 py-6 min-h-[100dvh] bg-white max-w-md mx-auto shadow-xl relative overflow-y-auto hide-scrollbar" data-id="element-89">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-64 bg-gradient-to-b from-green-50 to-white -z-10" data-id="element-90" />

      <img src={IMAGES.logo} alt="Código Metabólico" className="h-14 mb-5 object-contain" data-id="element-91" />

      <h1 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-dark mb-3 leading-tight" data-id="element-92">
        Tu metabolismo podría estar{' '}
        <span className="text-primary" data-id="element-93">saboteando tu dieta</span>
      </h1>

      <p className="text-gray-500 mb-3 text-sm sm:text-base" data-id="element-94">
        Descubre en 30 segundos qué tipo de metabolismo tiene tu cuerpo y qué
        alimentación funciona mejor para ti.
      </p>

      <p className="text-dark font-semibold mb-4 text-base sm:text-lg px-2" data-id="element-95">
        Existen 3 tipos de metabolismo… y la mayoría de personas está siguiendo
        la dieta equivocada.
      </p>

      {/* Social proof */}
      <div className="flex items-center gap-2 bg-blue-50 text-secondary px-4 py-2 rounded-full text-xs sm:text-sm font-medium mb-4" data-id="element-96">
        <Users className="w-4 h-4" data-id="element-97" />
        <span data-id="element-98">
          Más de 10,000 personas ya usaron este test para entender su
          metabolismo.
        </span>
      </div>

      {/* CTA Button */}
      <motion.button whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.95
    }} onClick={onStart} className="w-full bg-primary text-white text-lg sm:text-xl font-bold py-3.5 rounded-full shadow-lg shadow-primary/30 hover:bg-[#249e63] transition-colors mb-6" data-id="element-99">
        Descubrir mi metabolismo
      </motion.button>

      {/* Animal images */}
      <div className="flex justify-center gap-4 w-full mb-6" data-id="element-100">
        {[{
        name: 'Jaguar',
        emoji: '🐆',
        img: IMAGES.jaguar
      }, {
        name: 'Colibrí',
        emoji: '🐦',
        img: IMAGES.colibri
      }, {
        name: 'Oso',
        emoji: '🐻',
        img: IMAGES.oso
      }].map((animal, idx) => <motion.div key={animal.name} initial={{
        opacity: 0,
        scale: 0.8
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: idx * 0.15
      }} className="flex flex-col items-center gap-2 flex-1" data-id="element-101">
            <div className="w-20 h-20 rounded-2xl overflow-hidden shadow-md border-2 border-white relative" data-id="element-102">
              <img src={animal.img} alt={animal.name} className="w-full h-full object-cover" data-id="element-103" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" data-id="element-104" />
              <span className="absolute bottom-1 right-1 text-sm" data-id="element-105">
                {animal.emoji}
              </span>
            </div>
            <span className="text-sm font-semibold text-dark" data-id="element-106">
              {animal.name}
            </span>
          </motion.div>)}
      </div>

      <p className="text-gray-600 mb-6 px-4" data-id="element-107">
        Descubre cuál es el tuyo y qué tipo de alimentación funciona mejor para
        tu cuerpo.
      </p>
    </motion.div>;
}